import { gql } from "@apollo/client";

export interface LookupExternalCompanyFilter {
  sortDirection?: "ASC" | "DESC";
  sortBy?: "NAME" | "IDENTIFIER";
  searchTerm: string;
  identifierType?: IdentifierType;
  skip?: number;
  take?: number;
}

export type IdentifierType =
  | "ORGANIZATION_NUMBER"
  | "PERSON_IDENTIFIER"
  | "UNKNOWN";

export type ExternalLookupCompany = {
  id: string;
  identifier: string;
  identifierType: IdentifierType;
  name: string;
  address: string;
};

export interface ExternalLookupCompanyResult {
  lookup: {
    externalQuickLookup: {
      totalCount: number;
      items: Array<ExternalLookupCompany>;
    };
  };
}

const GET_EXTERNAL_LOOKUP_COMPANY = gql`
  query externalQuickLookup(
    $sortDirection: SortDirection
    $sortBy: ExternalQuickLookupSortBy
    $searchTerm: String!
    $identifierType: IdentifierType
    $skip: Int
    $take: Int
  ) {
    lookup {
      externalQuickLookup(
        sortDirection: $sortDirection
        sortBy: $sortBy
        searchTerm: $searchTerm
        identifierType: $identifierType
        skip: $skip
        take: $take
      ) {
        totalCount
        items {
          id
          identifier
          identifierType
          name
          address
        }
      }
    }
  }
`;

export default GET_EXTERNAL_LOOKUP_COMPANY;
